import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { SearchService } from '../../shared/services/search.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { Utility } from '../../shared/entities/utils';
import { SplitterModule } from 'primeng/splitter';
import { ColDef, GridApi, GridOptions, GridReadyEvent, ITextFilterParams, ModelUpdatedEvent } from 'ag-grid-community';
import { MaterialDataComponent } from './material-data/material-data.component';
import { QuantityDataComponent } from './quantity-data/quantity-data.component';
import { PaginationBarComponent } from '../../components/pagination-bar/pagination-bar.component';
import { SearchCriteria } from '../../shared/helpers/search-criteria/search-criteria';
import { FormsModule } from '@angular/forms';
import { MtaMtfComponent } from '../../components/mta-mtf/mta-mtf.component';
import { CompanyDropdownComponent } from '../../shared/company-dropdown/company-dropdown.component';
import { SearchBarComponent } from '../../components/search-bar/search-bar.component';


export interface HeaderOrderElementData {
  srno: boolean;
  cutomerpo: string;
  customerarticleno: string;
  orderpost: string;
  coilid: string;
  expdeldate: string;
  duedate: string;
  earlydate: string;
  steelgrade: string;
  producttype: string;
  averagewidth: string;
  averagethickness: string;
  weight: string;
}

@Component({
  selector: 'app-where-is-steel',
  standalone: true,
  providers: [SearchService],
  imports: [MatToolbarModule, MtaMtfComponent, SearchBarComponent, FormsModule, CompanyDropdownComponent, PaginationBarComponent, MatGridListModule, MaterialDataComponent, QuantityDataComponent, AgGridModule, MatTableModule, MatRadioModule, NgxSpinnerModule, AgGridModule,
    SplitterModule],
  templateUrl: './where-is-steel.component.html',
  styleUrl: './where-is-steel.component.scss'
})


export class WhereIsSteelComponent implements OnInit {
  selectedDropdwnData: any
  selectedCompany: any;
  mtaFlag: boolean = false;
  MTOFlag: boolean = true;
  selectedValueforheader: any;
  searchCriteria: SearchCriteria = new SearchCriteria();
  dataSearch: string = '';
  ELEMENT_DATA_ORDER_HEADER: HeaderOrderElementData[] = [];
  //flag for table view
  showordermaterialdatatable: boolean = false;
  @ViewChild('agGrid2', { static: true }) agGrid2?: AgGridAngular;
  @ViewChild('agGrid4', { static: true }) agGrid4?: AgGridAngular;
   public rowSelection: 'single' | 'multiple' = 'single';
  // public rowSelection!: 'single';
  materialOrderPost: any;
  dataSourceOrderHeader: any;
  dataSourceCoilHeader: any;
  colDefsOrder: ColDef[] = [];
  colDefsCoil: ColDef[] = [];
  private gridApi!: GridApi;
  orderheaderPagination: any;
  gridOptions: GridOptions = {
    defaultColDef: {
      filter: true
      
//   cellClass: 'ag-center-cell'

    },
    suppressCellFocus: true,
    suppressScrollOnNewData: true,
    suppressScrollWhenPopupsAreOpen: true,
    initialState: {
      rowSelection: ["0"],
    },
  };
  Unit: any;
  measuremntSystem: string = '';
  constructor(private _searchService: SearchService, private ngZone: NgZone, private spinner: NgxSpinnerService, private measurementsDataService: MeasurementsDataService, private cd: ChangeDetectorRef) {
    // this.spinner.show()
    this.Unit = this.measurementsDataService.regionMeasurementUnits()
    this.measurementsDataService.getMeasurementsData.subscribe((res: any) => {
      this.measuremntSystem = res;
    }
    )


  }
  changeViewForMTA() {
    if (this.mtaFlag) {
      this.mtaFlag = false;
    } else {
      this.mtaFlag = true;
    }
    this._searchService.orderPost.subscribe((res: any) => {
      this.materialOrderPost = res;
    })
    this.cd.detectChanges();
  }
  columnIntialization() {
    this.colDefsOrder = [
      {
        headerName: "Sr No.",
        field: "isSelected",
        flex: 0.5,
        cellRenderer: this.inputRowSelection.bind(this)
      },
      // { field: "customerOrderNumber", headerName: "Customer PO", flex: 1, autoHeaderHeight: true },
      // { field: "customerArticleNumber", headerName: "Customer Article Number", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
       { field: "customerReference", headerName: "Customer Refrence", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
      { field: "salesOrderNumber", headerName: "Order#", flex: 1, autoHeaderHeight: true },
      { field: "dueDate", headerName: "Due Date", flex: 1, autoHeaderHeight: true },
    ]
    this.colDefsCoil = [
      {
        headerName: "Sr No.",
        field: "isSelected",
        flex: 0.5,
        cellRenderer: this.inputRowSelection.bind(this)
      },
      // { field: "customerOrderNumber", headerName: "Customer PO", flex: 1, autoHeaderHeight: true },
      // { field: "customerArticleNumber", headerName: "Customer Article Number", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
       { field: "customerReference", headerName: "Customer Refrence", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
      { field: "salesOrderNumber", headerName: "Order#", flex: 1, autoHeaderHeight: true },
      { field: "coilSheetId", headerName: "Coil#", flex: 1, autoHeaderHeight: true },
      { field: "expectedDeliveryWeekDate", headerName: "Expected Delivery Date", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
      { field: "promisedDate", headerName: "Due Date", flex: 1, autoHeaderHeight: true },
      {
        field: "earlyLateInWeeks", headerName: "Early/late in weeks", flex: 1, wrapHeaderText: true, autoHeaderHeight: true,     cellClass: 'ag-center-cell',
        valueGetter: (params) => {
          if(params.data.earlyLateInWeeks>0){
return "+" + params.data.earlyLateInWeeks
          }
          else{
            return params.data.earlyLateInWeeks
          }
          },
         cellStyle: params => {
          if (params.value == -1 || params.value == 1 || params.value == 0) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            return { backgroundColor: 'green' , color:'white' };
          }
          if (params.value == 2) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            return { backgroundColor: 'amber' , color:'white' }
          }
          if (params.value == 3  || params.value == 4 ) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            return { backgroundColor: 'red' , color:'white'}
          }
          // if (params.value >-2 || params.value >= -4 ) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            // return { backgroundColor: 'red' , color:'white'}
          // }
          if (params.value > 4) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            return { backgroundColor: 'black', color:'white' }
          }
          if (params.value <= -2 ) {
            //mark police cells as red
            // return {color: 'red', backgroundColor: 'green'};
            return { backgroundColor: 'blue', color:'white' }
          }
          return null;
        }
      },
      { field: "gradeType", headerName: "Steel Grade", flex: 1, autoHeaderHeight: true },
      { field: "productType", headerName: "Product Type", flex: 1, autoHeaderHeight: true },
      { field: "width", headerName: `Average Width (${this.Unit.width_thickness})`, flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
      { field: "thickness", headerName: `Average Thickness (${this.Unit.width_thickness})`, flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
      { field: "weight", headerName: `Weight (${this.Unit.weight})`, flex: 1, autoHeaderHeight: true }
    ]
    this.searchCriteria = this._searchService.OdinHeaderSearchCriteria;
    this.searchCriteria.searchText = this.dataSearch;
    this.searchCriteria.page = 0;

  }

  comapnySelectionChange(data: any) {
    this.selectedCompany = data.companyList;
    if (this.selectedDropdwnData == '2') {
      this.getOdinHeaderDataOrder();
    } else {
      this.getOdinHeaderDataCoil();
    }

  }


  inputRowSelection(params: any) {
    let input = document.createElement('input');
    input.checked = params.value;
    input.type = "radio";
    input.name = 'serialno'
    input.className = "checkboxClass";
    input.addEventListener('click', () => this.clickEventForRadio(params));
    return input;
  }


  clickEventForRadio(params: any) {

    if (params.data) {
      this.primaryClick(params.data);
    }
    if (params.data.orderOFS != "MTO") {
      this.MTOFlag = false;
    } else {
      this.MTOFlag = true;
    }
    this.primaryClick(params.data);
    this.gridApi.forEachNode((node, index) => {
      if (index === params.rowIndex) {
        //below node code is for appliying css to selected row
        node.setSelected(true);
        // node.isSelected=true;

      } else {
        node.setSelected(false);
      }

    });
    this.gridApi.resetColumnGroupState();
    this.gridApi.resetColumnState()


    this.cd.detectChanges()

  }


  onSortChanged(event: any) {
    const sortModel = event.api.sortController.getSortModel();
    if (sortModel.length > 0) {
      this.searchCriteria.setSorting(sortModel[0].colId, sortModel[0].sort);
      if (this.selectedDropdwnData == '2') {
        this.getOdinHeaderDataOrder();
      } else {
        this.getOdinHeaderDataCoil();
      }
      // this.getOdinHeaderData();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }


  primaryClick(element: any) {

    // localStorage.removeItem('rowssteel');
    this.selectedValueforheader = element;
    this.materialOrderPost = null;

    // localStorage.setItem('rowssteel',element);
    this.ngZone.run(() => {
      if (element) {

        this.materialOrderPost = '';
        this.materialOrderPost = element
        this._searchService.updateOrderPoste(element.customerReference)
        this.showordermaterialdatatable = true;
      } else {
        this.showordermaterialdatatable = false;
      }

    });


    // this.getQualityStatusData(element.salesOrderNumber);
    element = null;
    // this.ELEMENT_DATA_MATERIAL = [];

    this.cd.detectChanges();
  }

  getOdinHeaderDataCoil() {
    this.spinner.show()
    this.orderheaderPagination = null;
    this.ELEMENT_DATA_ORDER_HEADER = [];
    this.dataSourceCoilHeader = null;
    this._searchService.getOdinHeaderDataCoil(this.searchCriteria, this.selectedCompany).subscribe((res: any) => {
      // res.isSelected=false;
      this.orderheaderPagination = res;
      this.spinner.hide();
      res.content.forEach((elementHeader: any) => {
        elementHeader.isSelected = false;
        if (this.measuremntSystem === 'US_CUSTOMARY_UNITS') {
          elementHeader.orderThickness = elementHeader.orderThickness ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderThickness)) * 1000) / 1000).toFixed(3) : '';
          elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderWidth)) * 1000) / 1000).toFixed(3) : '';
          elementHeader.weight = elementHeader.weight ? Utility.convertEUTonToUSTon(elementHeader.weight) : '';
        } else {
          elementHeader.orderThickness = elementHeader.orderThickness ? (Math.round((elementHeader.orderThickness) * 1000) / 1000).toFixed(2) : '';
          elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((elementHeader.orderWidth) * 1000) / 1000).toFixed(2) : '';
        }
        if (elementHeader.dueDate && elementHeader.expectedDeliveryDate) {
          let weeksValue = this.weeksBetween(new Date(elementHeader.dueDate), new Date(elementHeader.expectedDeliveryDate))
          elementHeader.weeks = weeksValue
        }



        this.ELEMENT_DATA_ORDER_HEADER.push(elementHeader);
      });
      this.dataSourceCoilHeader = this.ELEMENT_DATA_ORDER_HEADER;

      if (res.first && !this.selectedValueforheader) {
        this.dataSourceCoilHeader[0].isSelected = true;
        this.primaryClick(this.dataSourceCoilHeader[0]);
        if (this.dataSourceCoilHeader[0].orderOFS != 'MTO') {
          this.MTOFlag = false;
        } else {
          this.MTOFlag = true;
        }
        // this.gridApi.forEachNode((node, indexgrid) => {
        //   if (indexgrid === 0) {
        //     //below node code is for appliying css to selected row
        //     node.setSelected(true);
        //     // node.isSelected=true;

        //   } else {
        //     node.setSelected(false);
        //   }
        // })
      }
      if (this.selectedValueforheader) {
        if (this.selectedValueforheader.orderOFS != 'MTO') {
          this.MTOFlag = false;
        } else {
          this.MTOFlag = true;
        }
        for (let index = 0; index < this.dataSourceCoilHeader.length; index++) {
          const element = this.dataSourceCoilHeader[index];
          if (element.customerOrderNumber == this.selectedValueforheader.customerOrderNumber) {
            this.dataSourceCoilHeader[index].isSelected = true;
            this.primaryClick(this.dataSourceCoilHeader[index]);
            this.gridApi.forEachNode((node, indexgrid) => {
              if (indexgrid === index) {
                //below node code is for appliying css to selected row
                node.setSelected(true);
                // node.isSelected=true;

              } else {
                node.setSelected(false);
              }
            })
          }

        }
      }


    },
  (err)=>{
     this.spinner.hide();
  });

  }
  getOdinHeaderDataOrder() {
    this.spinner.show()
    this.orderheaderPagination = null;
    this.ELEMENT_DATA_ORDER_HEADER = [];
    this.dataSourceOrderHeader = null;
    this._searchService.getOdinHeaderDataOrder(this.searchCriteria, this.selectedCompany).subscribe((res: any) => {
      // res.isSelected=false;
      this.orderheaderPagination = res;
      this.spinner.hide();
      res.content.forEach((elementHeader: any) => {
        elementHeader.isSelected = false;
        if (this.measuremntSystem === 'US_CUSTOMARY_UNITS') {
          elementHeader.orderThickness = elementHeader.orderThickness ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderThickness)) * 1000) / 1000).toFixed(3) : '';
          elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderWidth)) * 1000) / 1000).toFixed(3) : '';
          elementHeader.weight = elementHeader.weight ? Utility.convertEUTonToUSTon(elementHeader.weight) : '';
        } else {
          elementHeader.orderThickness = elementHeader.orderThickness ? (Math.round((elementHeader.orderThickness) * 1000) / 1000).toFixed(2) : '';
          elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((elementHeader.orderWidth) * 1000) / 1000).toFixed(2) : '';
        }
        if (elementHeader.dueDate && elementHeader.expectedDeliveryDate) {
          let weeksValue = this.weeksBetween(new Date(elementHeader.dueDate), new Date(elementHeader.expectedDeliveryDate))
          elementHeader.weeks = weeksValue
        }



        this.ELEMENT_DATA_ORDER_HEADER.push(elementHeader);
      });
      this.dataSourceOrderHeader = this.ELEMENT_DATA_ORDER_HEADER;

      if (res.first && !this.selectedValueforheader) {
        this.dataSourceOrderHeader[0].isSelected = true;
        this.primaryClick(this.dataSourceOrderHeader[0]);
        if (this.dataSourceOrderHeader[0].orderOFS != 'MTO') {
          this.MTOFlag = false;
        } else {
          this.MTOFlag = true;
        }
        // this.gridApi.forEachNode((node, indexgrid) => {
        //   if (indexgrid === 0) {
        //     //below node code is for appliying css to selected row
        //     node.setSelected(true);
        //     // node.isSelected=true;

        //   } else {
        //     node.setSelected(false);
        //   }
        // })
      }
      if (this.selectedValueforheader) {
        if (this.selectedValueforheader.orderOFS != 'MTO') {
          this.MTOFlag = false;
        } else {
          this.MTOFlag = true;
        }
        for (let index = 0; index < this.dataSourceOrderHeader.length; index++) {
          const element = this.dataSourceOrderHeader[index];
          if (element.customerOrderNumber == this.selectedValueforheader.customerOrderNumber) {
            this.dataSourceOrderHeader[index].isSelected = true;
            this.primaryClick(this.dataSourceOrderHeader[index]);
            this.gridApi.forEachNode((node, indexgrid) => {
              if (indexgrid === index) {
                //below node code is for appliying css to selected row
                node.setSelected(true);
                // node.isSelected=true;

              } else {
                node.setSelected(false);
              }
            })
          }

        }
      }


    },
   (err)=>{
     this.spinner.hide();
  });

  }

  // getOdinHeaderData() {
  //   this.orderheaderPagination = null;
  //   this.ELEMENT_DATA_ORDER_HEADER = [];
  //   this.dataSourceOrderHeader = null;
  //   this._searchService.getOdinHeaderData(this.searchCriteria).subscribe((res: any) => {
  //     // res.isSelected=false;
  //     this.orderheaderPagination = res;
  //     this.spinner.hide();
  //     res.content.forEach((elementHeader: any) => {
  //       elementHeader.isSelected = false;
  //       if (this.measuremntSystem === 'US_CUSTOMARY_UNITS') {
  //         elementHeader.orderThickness = elementHeader.orderThickness ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderThickness)) * 1000) / 1000).toFixed(3) : '';
  //         elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((Utility.convertMillimeterToInch(elementHeader.orderWidth)) * 1000) / 1000).toFixed(3) : '';
  //         elementHeader.weight = elementHeader.weight ? Utility.convertEUTonToUSTon(elementHeader.weight) : '';
  //       } else {
  //         elementHeader.orderThickness = elementHeader.orderThickness ? (Math.round((elementHeader.orderThickness) * 1000) / 1000).toFixed(2) : '';
  //         elementHeader.orderWidth = elementHeader.orderWidth ? Number(Math.round((elementHeader.orderWidth) * 1000) / 1000).toFixed(2) : '';
  //       }
  //       if (elementHeader.dueDate && elementHeader.expectedDeliveryDate) {
  //         let weeksValue = this.weeksBetween(new Date(elementHeader.dueDate), new Date(elementHeader.expectedDeliveryDate))
  //         elementHeader.weeks = weeksValue
  //       }



  //       this.ELEMENT_DATA_ORDER_HEADER.push(elementHeader);
  //     });
  //     this.dataSourceOrderHeader = this.ELEMENT_DATA_ORDER_HEADER;

  //     if (res.first && !this.selectedValueforheader) {
  //       this.dataSourceOrderHeader[0].isSelected = true;
  //       this.primaryClick(this.dataSourceOrderHeader[0]);
  //       if (this.dataSourceOrderHeader[0].orderOFS != 'MTO') {
  //         this.MTOFlag = false;
  //       } else {
  //         this.MTOFlag = true;
  //       }
  //       this.gridApi.forEachNode((node, indexgrid) => {
  //         if (indexgrid === 0) {
  //           //below node code is for appliying css to selected row
  //           node.setSelected(true);
  //           // node.isSelected=true;

  //         } else {
  //           node.setSelected(false);
  //         }
  //       })
  //     }
  //     if (this.selectedValueforheader) {
  //       if (this.selectedValueforheader.orderOFS != 'MTO') {
  //         this.MTOFlag = false;
  //       } else {
  //         this.MTOFlag = true;
  //       }
  //       for (let index = 0; index < this.dataSourceOrderHeader.length; index++) {
  //         const element = this.dataSourceOrderHeader[index];
  //         if (element.customerOrderNumber == this.selectedValueforheader.customerOrderNumber) {
  //           this.dataSourceOrderHeader[index].isSelected = true;
  //           this.primaryClick(this.dataSourceOrderHeader[index]);
  //           this.gridApi.forEachNode((node, indexgrid) => {
  //             if (indexgrid === index) {
  //               //below node code is for appliying css to selected row
  //               node.setSelected(true);
  //               // node.isSelected=true;

  //             } else {
  //               node.setSelected(false);
  //             }
  //           })
  //         }

  //       }
  //     }


  //   });

  // }


  onSearch(event: any) {
    // if (data.selected === '2') {
    //        this.gridApiOrder.resetColumnState();
    //      this.searchText = data.text;
    //       this.searchCriteria.searchText = this.searchText;
    //       this.searchCriteria.page = 0;
    //       const navigationExtras: NavigationExtras = {queryParams: {searchText: this.searchText, shouldShowDisclaimer: this.shouldShowDisclaimer}};
    //       this.router.navigate(['orders'], navigationExtras);
    //       this.doSearchOrderAPICall();
    //     } else {
    //       this.searchCoilData(data.text,this.selectedCmpList);
    //     }
    this.selectedDropdwnData = null;
    //resetting into new search, all the previous pagination info and other info needed to be cleared
    this.gridApi.resetColumnState();
    this.searchCriteria.searchText = event.text;
    this.searchCriteria.page = 0;
    this.selectedDropdwnData = event.selected;
    // this.getOdinHeaderData();
    // console.log(" this.searchCriteria", this.searchCriteria)
    if (event.selected == '2') {
      this.getOdinHeaderDataOrder();
    } else {
      this.getOdinHeaderDataCoil();
    }

  }

  doOrderHeaderPageSearch(pagetToSearch: number) {
    this.materialOrderPost = '';
    //ensuring the firstpage -1  and last page+1 search is irrelavent  + Also ensuring the current number search once again for the Last & First
    if (pagetToSearch != this.orderheaderPagination.number && pagetToSearch >= 0 && pagetToSearch < this.orderheaderPagination.totalPages) {
      this.searchCriteria.page = pagetToSearch;
      if (this.selectedDropdwnData == '2') {
        this.getOdinHeaderDataOrder();
      } else {
        this.getOdinHeaderDataCoil();
      }

    }
    // else{
    //   if(pagetToSearch<0){
    //     this.router.navigate([''])
    //   }
    // }

  }

  weeksBetween(d1: any, d2: any) {
    return Math.round((d2 - d1) / (7 * 24 * 60 * 60 * 1000));
  }

  ngOnInit(): void {
    this.columnIntialization();
    if (this.selectedDropdwnData == '2') {
      this.getOdinHeaderDataOrder();
    } else {
      this.getOdinHeaderDataCoil();
    }
    // this.getOdinHeaderData();


    // if(this.gridOptions.initialState)
  }

  getProjection(value: any) {
    // console.log(value);
  }

  //Keeping the first row always selected
    onModelUpdated(event: ModelUpdatedEvent){
      event.api.forEachNode((node, index) => {
        if (index === 0) {
          node.setSelected(true);
        }
      });
    }
  

    
  onOrderSelectionChanged() {
    const selectedRows = this.gridApi.getSelectedRows();
    this.selectedValueforheader = selectedRows[0];
    // if(this.selectedValueforheader?._id) {
    //   this.getOrderCoilSheets(this.selectedOrder._id);
    // }
    this.mtaFlag=false;
   if(this.selectedValueforheader?.customerReference) {

        this.materialOrderPost = '';
        this.materialOrderPost = this.selectedValueforheader
        // this._searchService.updateOrderPoste(this.selectedValueforheader.customerReference)
        this.showordermaterialdatatable = true;
      } else {
        this.showordermaterialdatatable = false;
      }
  }

  checkForPAgeNUmberChange(event:any){
    if(event){
      this.searchCriteria.page=+event-1;
       if (this.selectedDropdwnData == '2') {
      this.getOdinHeaderDataOrder();
    } else {
      this.getOdinHeaderDataCoil();
    }
    }

  }
}
